<div class="container">
  <div class="c__content">
    <div class="c__information-container col-24 {{navigationFooter?.length >= 3 ? 'is-flex-start' : ''}}">
      @if (!isDevice()) {

        @for (item of navigationFooter; track item.title) {
          <div class="is-col col-m-10 col-l-5">
            @if (item.title) {
              <p class="c__title is-body-l is-bold" role="heading" [attr.aria-level]="titleLevel">
                {{ item.title }}
              </p>
            }
            @if (item.children) {
              <ul>
                @for (child of item.children; track $index) {
                  <li>
                    @if (child['linkName']) {
                      <sd-link [link]="child" [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light">
                        {{ child['linkName'] }}
                      </sd-link>
                    }
                    @if (child['medias']) {
                      @for (media of child['medias']; track media.code) {
                        <sd-banner [media]="media" />
                      }
                    }
                  </li>
                }
              </ul>
            }
          </div>
        }

        @if (contact || location) {
          <div class="is-col col-m-10 col-l-5">
            @if (contact) {
              <div class="c__contact">
                @if (contact.title) {
                  <p class="c__title is-body-l is-bold">{{ contact.title }}</p>
                }
                <ng-container *ngTemplateOutlet="$contact" />
              </div>
            }
            @if (location) {
              <div class="c__location">
                @if (location.title) {
                  <p class="c__title is-body-l is-bold">{{ location.title }}</p>
                }
                <ng-container *ngTemplateOutlet="$location" />
              </div>
            }
            @if (review?.type === reviewEnum.IMAGE) {
              <div class="c__avis-verifies">
                <div [attr.id]="review.id"></div>
              </div>
            }
          </div>
        }

      } @else if (navigationFooter) {

        <sd-accordion-group [closeOthers]="true" [hideOthers]="false" [clickOutsideToClose]="false">
          @for (item of navigationFooter; track item.title; let isFirst = $first) {
            <sd-accordion
              [title]="item.title"
              [titleLevel]="titleLevel"
              [iconSize]="iconSize.small"
              iconNameOpened="icon-minus"
              iconNameClosed="icon-plus"
              [iconPos]="positionEnum.right"
              [isDrawer]="true"
              [isVisible]="true"
              [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light"
              [isOpened]="isFirst"
            >
              @if (item.children) {
                <ul>
                  @for (child of item.children; track $index) {
                    <li>
                      @if (child['linkName']) {
                        <sd-link [link]="child" [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light">
                          {{ child['linkName'] }}
                        </sd-link>
                      }
                      @if (child['medias']) {
                        @for (media of child['medias']; track media) {
                          <sd-banner [media]="media" />
                        }
                      }
                    </li>
                  }
                </ul>
              }
            </sd-accordion>
          }

          @if (contact) {
            <sd-accordion
              [title]="contact.title"
              [titleLevel]="titleLevel"
              [iconSize]="iconSize.small" iconNameOpened="icon-minus"
              iconNameClosed="icon-plus" [iconPos]="positionEnum.right"
              [isDrawer]="true" [isVisible]="true"
              [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light"
            >
              <ng-container *ngTemplateOutlet="$contact" />
            </sd-accordion>
          }

          @if (location) {
            <sd-accordion
              [title]="location.title"
              [titleLevel]="titleLevel"
              [iconSize]="iconSize.small" [isVisible]="true"
              iconNameOpened="icon-minus" iconNameClosed="icon-plus"
              [iconPos]="positionEnum.right" [isDrawer]="true"
              [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light"
            >
              <ng-container *ngTemplateOutlet="$location" />
            </sd-accordion>
          }

        </sd-accordion-group>
      }
    </div>

  </div>

  @if (serviceOptions) {
    <div class="c__content">
      <div class="c__information-container col-24 {{serviceOptions?.length <= 2 ? 'is-flex-start' : ''}}">
        @if (review?.type === reviewEnum.CAROUSEL) {
          <div class="is-col col-24 col-l-10 c__avis-verifies">
            <div [class]="review.id"></div>
          </div>
        }
        @for (item of serviceOptions; track $index) {
          <div class="c__service-option is-col col-24 col-l-5">
            @if (item.title) {
              <p class="c__title is-body-l is-bold" role="heading" [attr.aria-level]="titleLevel">
                {{ item.title }}
              </p>
            }
            @if (item.medias) {
              <div class="media__list">
                @for (media of item.medias; track media.code) {
                  <div class="media__list_item d-block">
                    <sd-banner [media]="media" />
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (!(review?.type === reviewEnum.CAROUSEL) && !isDevice()) {
          <div class="col-24 is-col col-m-10 col-l-5"></div>
          <div class="col-24 is-col col-m-10 col-l-5"></div>
        }
      </div>
    </div>
  }
</div>

<ng-template #$location>
  @if (location.address) {
    <sd-html [html]="location.address" innerClass="is-wysiwyg is-medium" />
  }
</ng-template>

<ng-template #$contact>
  <ul>
    @if (contact.mail) {
      <li class="d-flex align-items-center">
        <sd-icon [size]="iconSize.xs" name="icon-mail" />
        <a [href]="'mailto:' + contact.mail">
          {{ contact.mail }}
        </a>
      </li>
    }
    @if (contact.phone) {
      <li class="d-flex align-items-center">
        <sd-icon [size]="iconSize.xs" name="icon-phone" />
        <a [href]="'tel:' + contact.phone">
          {{ contact.phone }}
        </a>
      </li>
    }
  </ul>
</ng-template>
